/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type FieldValueType = typeof FieldValueType[keyof typeof FieldValueType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FieldValueType = {
  Text: 'Text',
  ImageDataURI: 'ImageDataURI',
} as const;
